"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthVerify = void 0;
const react_1 = require("react");
const constants_1 = require("../utils/constants");
function useAuthVerify() {
    const verify = () => {
        const parentUrl = document.referrer;
        // const connectedSessions = window.localStorage.getItem('tria.connected.apps');
        // if (connectedSessions) {
        //   const apps = JSON.parse(connectedSessions);
        //   if (apps.includes(parentUrl)) {
        //   }
        // }
        const triaStore = window.localStorage.getItem(constants_1.TRIA_WALLET_STORE);
        if (triaStore) {
            window.parent.postMessage(JSON.stringify({
                type: 'Verify Sign up',
                success: 'true',
                data: JSON.parse(triaStore),
            }));
        }
    };
    (0, react_1.useEffect)(() => {
        verify();
    }, []);
}
exports.useAuthVerify = useAuthVerify;
